import { Form, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TenantForm from './TenantForm';
import styles from './tenant-modal.less';

const TenantModal = ({ title, loading, onSubmit, ...props }) => {
  const [t] = useTranslation();
  const [form] = Form.useForm();

  const submitTenant = async () => {
    const values = await form.validateFields();
    onSubmit(values);
  };

  return (
    <Modal
      title={title}
      width={703}
      className={styles.userModal}
      cancelText={t('button.cancel')}
      okText={t('button.create-in-short')}
      onOk={submitTenant}
      confirmLoading={loading}
      {...props}
    >
      <TenantForm form={form} />
    </Modal>
  );
};

export default TenantModal;
